class SwymWishlistButton extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.containerId = this.dataset.swymBtnContainer
    this.isSectionRendered = this.dataset.isSectionRendered === 'true'
    this.button = this.querySelector('button')

    if (!this.button) return

    if (this.isSectionRendered && !this.button.classList.contains('swym-loaded')) {
      const swymBtnString = `[data-swym-btn-container="${this.containerId}"]`

      window?.SwymCallbacks?.push(function(swat) {
        swat.initializeActionButtons(swymBtnString)
      })
    }
  }
}

customElements.define('swym-wishlist-button', SwymWishlistButton);
